import React from "react";
import { Link } from "react-router-dom";
import { getTargetFromType } from "./useOpenLink";

const CustomLink = ({ to, type, link, children, ...props }) => {
    if (!to) return children;

    if (to.startsWith("#")) {
        return (
            <a
                href={to}
                onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = to;

                    const el = document.getElementById(to.substring(1));
                    if (el) {
                        const offset = 120;
                        const top = el.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: "smooth" });
                    }
                }}
                {...props}
            >
                {children}
            </a>
        );
    }

    if (to.startsWith("http") || to.startsWith("mailto:") || to.startsWith("tel:")) {
        return (
            <a
                href={to}
                target={getTargetFromType(type, link)}
                rel="noopener noreferrer"
                {...props}
            >
                {children}
            </a>
        );
    }

    return (
        <Link to={to} target={getTargetFromType(type, link)} {...props}>
            {children}
        </Link>
    );
};

export default CustomLink;
